import React from "react";
import Image from "../image/Image";
import LinkWrapper from "../linkWrapper/LinkWrapper";
import { getImageLink } from "../../../utils/images";
import { decodeText, prepareRichText } from "../../../utils/richText";
import { getChildEntries } from "../../../utils/nodes";
import { getAlignmentClasses } from "../../../utils/alignment";

const getLinks = ({ links }) => getChildEntries(links).filter(({ node }) => node.label);

const SlideContent = ({ badge, eyebrow, title, text, links, justifyClass, light, textClass }) => (
    <div className={`slider-content slider-animated-1 ${textClass}`}>
        {badge && <span className="badge bg-purple-2 text-dark text-uppercase mb-3 animated d-inline-block">{decodeText(badge)}</span>}
        {eyebrow && <h3 className={`animated ${light ? "slider-light" : ""}`}>{decodeText(eyebrow)}</h3>}
        {title && <h1 className={`animated ${light ? "slider-light" : ""}`}>{decodeText(title)}</h1>}
        {text && (
            <div
                className={`slider-text animated ${light ? "slider-light" : ""}`}
                dangerouslySetInnerHTML={{ __html: prepareRichText(text) }}
            ></div>
        )}
        {links.length > 0 && (
            <div className={`slider-btn btn-hover d-flex flex-wrap gap-3 ${justifyClass}`}>
                {/* The theme's .slider-btn a is near-black with a dark border — inline
                    white on the full-background layout, or the CTA vanishes on the scrim. */}
                {links.map(({ name, node }) => (
                    <LinkWrapper
                        key={name}
                        linkNode={node}
                        linkClass="animated"
                        linkStyle={light ? { color: "#fff", borderColor: "#fff" } : undefined}
                    >
                        {decodeText(node.label)}
                    </LinkWrapper>
                ))}
            </div>
        )}
    </div>
);

const HeroSlide = (props) => {
    const { layout = "split", textAlignment = "left", verticalAlignment = "bottom" } = props;

    const { textAlignmentClass, horizontalAlignmentClass, verticalAlignmentClass } = getAlignmentClasses({
        textAlignment,
        horizontalAlignment: textAlignment,
        verticalAlignment,
    });
    const textAlignClass = `${textAlignmentClass} ${horizontalAlignmentClass}`;

    const content = (
        <SlideContent
            badge={props.badge}
            eyebrow={props.eyebrow}
            title={props.title}
            text={props.text}
            links={getLinks(props)}
            justifyClass={horizontalAlignmentClass}
            light={layout === "full"}
            textClass={layout === "full" ? textAlignmentClass : ""}
        />
    );

    if (layout === "full") {
        const src = getImageLink(props.image);

        const dark = "rgba(17, 24, 39, 0.75)";
        const scrim =
            {
                left: `linear-gradient(to right, ${dark} 0%, transparent 100%)`,
                right: `linear-gradient(to left, ${dark} 0%, transparent 100%)`,
            }[textAlignment] || `linear-gradient(to right, transparent -25%, ${dark} 50%, transparent 125%)`;
        const contentStyle = { maxWidth: "560px", margin: "3rem 0" };

        return (
            <div
                className={`single-slider slider-height-1 position-relative ${verticalAlignmentClass}`}
                style={{
                    backgroundImage: src ? `url(${src})` : undefined,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="position-absolute top-0 start-0 w-100 h-100" style={{ background: scrim }} />
                <div className="container position-relative">
                    <div className={`d-flex ${textAlignClass}`}>
                        <div style={contentStyle}>{content}</div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="single-slider slider-height-1 bg-purple">
            <div className="container">
                <div className={`row ${layout === "splitReverse" ? "flex-row-reverse" : ""} ${verticalAlignmentClass}`}>
                    <div className={`col-xl-5 col-lg-5 col-md-6 col-12 col-sm-6 ${textAlignClass}`}>{content}</div>

                    {props.image && (
                        <div className="col-xl-7 col-lg-7 col-md-6 col-12 col-sm-6 order-first order-sm-0">
                            <div className="slider-single-img slider-animated-1">
                                <Image imageNode={props.image} className="animated img-fluid" />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default HeroSlide;
